import Cookies from 'js-cookie';

export default class FormUtils {
  static createFormData(fieldNames, form) {
    const formFields = fieldNames.split(',');
    const formData = Object.fromEntries(formFields
      .filter((item) => item !== 'check')
      .map((item) => [item, ''])
    );

    return Object.assign(formData, form);
  }

  static redirectToThankYouPage() {
    const currentUrl = window.location.origin + window.location.pathname.replace(/\/+$/, '');
    Cookies.set('thankYouPageAccess', true);
    window.location.href = `${currentUrl}/thank-you`;
  }

  static findEmptyField(formData, excludedFields, refs) {
    const emptyFieldName = Object.keys(formData).find((key) => {
      const element = refs[key]?.$el;
      const isExcluded = excludedFields.includes(key);
      
      if (!isExcluded) {
        return !element.validity.valid;
      }
    });

    if (emptyFieldName) {
      refs[emptyFieldName].$el.focus();
      return true;
    }

    return false;
  }

  static submitForm(url, formData, handleSuccess, handleError) {
    formData.roistat = Cookies.get('roistat_visit');

    return fetch(url, {
      method: 'post',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((r) => r.json().then((json) => [r.status, json]))
      .then(([status, json]) => {
        if (status === 200) {
          handleSuccess();
        } else {
          handleError();
        }

        return json;
      })
      .catch(() => {
        handleError();
      });
  }

  static xsrfFormHtml(token) {
    return `<input type="hidden" name="_xsrf" value="${token}">`;
  }
}
